module.exports = __webpack_public_path__ + "img/Image_4.6c4b858b.png";